import { BrandType, Country } from '../../../generated/graphql';

export const resolveBrandCountry = (): { brand: BrandType, country?: Country } => {
  const INDEX_COUNTRY_KEY = 'INDEX_COUNTRY_KEY';
  const params = new URLSearchParams(window.location.search);
  const countryURL = params.get('country')?.toUpperCase();
  const country = localStorage.getItem(INDEX_COUNTRY_KEY)?.toUpperCase() || Country.Co;

  if (
    process.env.NODE_ENV === 'development'
    || process.env.REACT_APP_FORCE_BRAND_FROM_QUERY === 'true'
  ) {
    const storedBrand = sessionStorage.getItem('brand');
    const brand = params.get('brand') || storedBrand || BrandType.Tranquiapp;
    sessionStorage.setItem('brand', brand);
    if (brand) return { brand: brand as BrandType };
  }

  const INDEX_BRAND_KEY = 'INDEX_BRAND_KEY';
  const brandLS = localStorage.getItem(INDEX_BRAND_KEY) || BrandType.Tranquiapp;
  const brands = Object.values(BrandType);
  const brandTypeLS = brands.find((brand) => brand.toLowerCase() === brandLS.toLowerCase());
  if (brandTypeLS) return { brand: brandTypeLS };

  return { brand: BrandType.Tranquiapp, country: (countryURL || country) as Country };
};
